import logo from "./assets/header.png";
import "./style.scss";

import chars from "./assets/chars.png";
import winchester from "./assets/winchester.png";

import aleister from "./assets/aleister.png";
import ReactPlayer from "react-player";
import { useState } from "react";
import packshotPS5 from "./assets/flc-packshot-ps5.png";
import packshotXbox from "./assets/flc-packshot-xbox.png";
import packshotPcRise from './assets/packshot-risetoglory.jpeg'
import packshotPcRevenants from './assets/packshot-revenants.jpeg'
import { Smoke } from "./Smoke";

function App() {
  return (
    <div id="app" className="flex fit">
      <Header />
      <NewContent />
      <LearnMore />
      <Characters />
      <Bottom />
      <Smoke b={3} clouds={10} />
      <Retailers />
      <Footer />
    </div>
  );
}

export default App;

const Header = () => {
  return (
    <header className="flex fit">
      <img src={logo} className="App-logo" alt="logo" />
    </header>
  );
};

const LearnMore = () => {
  return (
    <div className="flex fit" id="learn">
      <div className="flex">
        <a href="https://fallenlegiongame.com/rise-to-glory" target={"_blank"}>
          <h2 className="fl1">
            Learn more about Fallen Legion: Rise to Glory!
          </h2>
        </a>
        <a href="https://fallenlegiongame.com/revenants" target={"_blank"}>
          <h2 className="fl2">Learn more about Fallen Legion Revenants!</h2>
        </a>
      </div>
    </div>
  );
};

const Characters = () => {
  return (
    <div id="characters" className="flex fit">
      <h2 style={{ textAlign: "center" }}>
        Exceptional Exemplars return!
        <br />
        Winchester and Aleister are eager for action!
      </h2>
      <div className="flex row fit">
        <img src={chars} alt="" style={{ width: "100%", maxWidth: 1100 }} />
      </div>
    </div>
  );
};

const NewContent = () => {
  return (
    <div id="new-content" className="flex fit">
      <p>
        In the face of adversity, how will you choose your fate?{" "}
        <i>Fallen Legion: Rise to Glory / Fallen Legion Revenants</i> puts you
        at the forefront of your adventure where every choice you make
        determines the life or death of those around you. Will you seek
        vengeance or the crown?
      </p>
    </div>
  );
};

const Bottom = () => {
  return (
      <div className='flex' id='bottom'>
          <div className='flex row wrap'>
              <div className='detail-box flex'>
                  <h3>Fallen Legion: Rise to Glory /</h3>

                  <h3>Fallen Legion Revenants</h3>
                  <p>Available Now</p>
                  <p>Platforms: PS5™, Xbox, PC</p>
                  <p className='center red'>
                      Available individually on all <span style={{ whiteSpace: 'nowrap' }}>platforms digitally</span>
                  </p>
              </div>
              {/* <div className="detail-box flex">
          <h3>Fallen Legion Revenants</h3>
          <p>Release Date:8/23/22</p>
          <p>Platforms: PS5, Xbox</p>
          <p>Available individually on PC</p>
        </div> */}
          </div>
          <h2>An exemplary collection packed with new content:</h2>
          <ul>
              <li>
                  New playable character in <i>Rise to Glory</i>: Aleister
              </li>
              <li>
                  New playable character in <i>Revenants</i>: Winchester
              </li>
              <li>
                  BlazBlue Exemplar Costume DLC available for purchase for <i>Fallen Legion Revenants</i>
              </li>
              <li style={{ color: 'rgb(255, 217, 0)' }}>
                  <i>Revenants</i> is rebuilt with the Crimson Rose update! This adds new features including:
              </li>
              <ul>
                  <li style={{ color: 'rgb(255, 236, 131)', transform: 'scale(.9)' }}>
                      Choose your challenge level with selectable difficulty modes.
                  </li>
                  <li style={{ color: 'rgb(255, 236, 131)', transform: 'scale(.9)' }}>
                      New Archeus Fusion system offers more ways to enhance characters.
                  </li>
                  <li style={{ color: 'rgb(255, 236, 131)', transform: 'scale(.9)' }}>
                      Additional weapons and deathblows to discover.
                  </li>
                  <li style={{ color: 'rgb(255, 236, 131)', transform: 'scale(.9)' }}>
                      New mana chain attacks to master.
                  </li>
                  <li style={{ color: 'rgb(255, 236, 131)', transform: 'scale(.9)' }}>
                      Faster battle speed and rebalanced gameplay.
                  </li>
                  <li style={{ color: 'rgb(255, 236, 131)', transform: 'scale(.9)' }}>
                      Pick either English or Japanese voiceover options.
                  </li>
              </ul>
          </ul>
      </div>
  )
};

const Retailers = () => {
  const [modal, setModal] = useState(false);
  const [platform, setPlatform] = useState("ps5");
  const games = {
      ps5: { img: packshotPS5, url: 'https://store.nisamerica.com' },
      xbox: { img: packshotXbox, url: 'https://store.nisamerica.com' },
      
  }
  return (
      <>
          <div className='flex' style={{ marginBottom: 64 }}>
              <h2 className='fl1 center' onClick={() => setModal(true)}>
                  Purchase
              </h2>
              <h3 style={{ backgroundColor: '#811810', color: '#dab120', padding: '1rem' }}>Watch the trailers</h3>
              <ReactPlayer style={{ paddingBottom: '1rem' }} url='https://www.youtube.com/watch?v=VPIMsdwHMkA' />{' '}
              <ReactPlayer style={{ paddingBottom: '1rem' }} url='https://www.youtube.com/watch?v=Qq9a7aPfUCE' />{' '}
              <ReactPlayer style={{ paddingBottom: '1rem' }} url='https://www.youtube.com/watch?v=284Qpkv5n3Y' />{' '}
              <ReactPlayer style={{ paddingBottom: '1rem' }} url='https://www.youtube.com/watch?v=Y7e-edSyCME' />{' '}
              <h3 style={{ backgroundColor: '#811810', color: '#dab120', padding: '1rem' }}>
                  Watch the Fallen Legion: Rise to Glory Music Clip | Frigid Clash
              </h3>
              <ReactPlayer url='https://www.youtube.com/watch?v=UFoxPLeNOVY' />{' '}
              <h3 style={{ backgroundColor: '#811810', color: '#dab120', padding: '1rem' }}>
                  Watch the Fallen Legion Revenants Music Clip | Cast Aside Any Doubts
              </h3>
              <ReactPlayer url='https://www.youtube.com/watch?v=-gimWpITFys' />{' '}
          </div>
          <div id='modal' className='flex' style={{ display: modal ? 'flex' : 'none' }} onClick={() => setModal(false)}>
              <div id='modal-close'>Close</div>
              <div className='modal-content flex' onClick={(e) => e.stopPropagation()}>
                  <div className='flex row'>
                      <div className='platform' onClick={() => setPlatform('ps5')}>
                          PS5™
                      </div>
                      <div className='platform' onClick={() => setPlatform('xbox')}>
                          {' '}
                          Xbox One/Series X
                      </div>{' '}
                      <div className='platform' onClick={() => setPlatform('pc')}>
                          {' '}
                          PC
                      </div>
                  </div>
                  {platform === 'pc' ? (
                      <>
                          {' '}
                          <img classname='packshot' src={packshotPcRise} alt='rise to glory packshot' />
                          <a
                              href='https://store.steampowered.com/app/612820/Fallen_Legion_Rise_to_Glory/'
                              target={'_blank'}
                              rel='noreferrer'
                              className='center'
                          >
                              Steam
                          </a>
                          <img classname='packshot' src={packshotPcRevenants} alt='rise to glory packshot' />
                          <a
                              href='https://store.steampowered.com/app/1921340/Fallen_Legion_Revenants/'
                              target={'_blank'}
                              className='center'
                              rel='noreferrer'
                          >
                              Steam
                          </a>
                      </>
                  ) : (
                      <>
                          <img classname='packshot' src={games[platform].img} alt='' />{' '}
                          <a href={games[platform].url} target={'_blank'} className='center' rel='noreferrer'>
                              NISA Online Store
                          </a>
                      </>
                  )}
              </div>
          </div>
      </>
  )
};

const Footer = () => {
  return (
    <footer className="flex fit">
      <div className="flex row wrap logos">
        <img
          src="https://nisamerica.com/public/assets/logo/yummyyummyyummy.png"
          alt=""
          height={50}
        />
        <img
          src="https://nisamerica.com/public/assets/logo/nisa.webp"
          alt=""
          width={80}
        />
        <img
          src="https://nisamerica.com/public/assets/logo/ps5.png"
          alt=""
          height={50}
        />
        <img
          src="https://nisamerica.com/public/assets/logo/xbox-one.png"
          alt=""
          height={50}
        />
        <img
          src="https://nisamerica.com/public/assets/logo/xbox-series-x.png"
          alt=""
          height={50}
        />
        <img
          src="https://nisamerica.com/public/assets/logo/pc.png"
          alt=""
          width={50}
        />
      </div>
      <p>
        ©YummyYummyTummy, Inc. Licensed to and published by NIS America, Inc.
      </p>
      <p>
        ©2022 Sony Interactive Entertainment LLC. “PlayStation Family Mark",
        “PlayStation”, “PS5 logo”, “PS5”, “PS4 logo”, “PS4”, “PlayStation Shapes
        Logo” and "Play Has No Limits" are registered trademarks or trademarks
        of Sony Interactive Entertainment Inc.
      </p>
      <p>
        Microsoft, the Xbox Sphere mark, the Series X logo, Series S logo,
        Series X|S logo, Xbox One, Xbox Series X, Xbox Series S, and Xbox Series
        X|S are trademarks of the Microsoft group of companies.
      </p>
    </footer>
  );
};
